/**
 * Application route constants
 * 
 * Centralized route definitions for type-safe navigation
 */

export const ROUTES = {
  // Public routes
  AUTH: {
    LOGIN: '/auth/login',
    REGISTRATION: '/auth/registration',
    RECOVERY: '/auth/recovery',
    VERIFICATION: '/auth/verification',
    SETTINGS: '/auth/settings',
  },
  
  // Protected routes
  HOME: '/',
  DASHBOARD: '/dashboard',
  FACE_RECOGNITION_METRICS: '/dashboard/face-recognition',
  WELCOME: '/welcome',
  PROJECTS: '/projects',

  ACCOUNT: {
    SECURITY: '/account/security',
  },
  
  ORGANIZATION_SETTINGS: {
    INDEX: '/organization-settings',
    MEMBERS: '/organization-settings/members',
    SECURITY: '/organization-settings/security',
    SSO: '/organization-settings/sso',
    DANGER_ZONE: '/organization-settings/danger-zone',
  },
  
  PROJECT_SETTINGS: {
    INDEX: '/project-settings',
  },

  ELECTRONIC_SIGNATURE: {
    METRICS: '/electronic-signature/metrics',
    LIST: '/electronic-signature/list',
    SETTINGS: '/electronic-signature/settings',
  },

  TABLES: {
    IDENTITY_VALIDATION: '/tables/identity-validation',
    FACE_RECOGNITION: '/tables/face-recognition',
  },
  
  IDP: {
    IDENTITIES_LIST: '/tables/idp/identities-list',
    USER_PROFILE: '/tables/idp/user-profile',
  },
  
  SETTINGS: {
    AI_THRESHOLDS: '/settings/aithresholds',
    DEVICE_INTEGRITY: '/settings/device-integrity',
    IDP_OAUTH2: '/settings/idp/oauth2',
    OAUTH_CLIENTS: '/settings/idp/oauth2/oauth-clients',
    OAUTH_SECURITY: '/settings/idp/oauth2/security',
    IP_BLOCKING: '/settings/ipblocking',
  },

  DOCS: {
    INDEX: '/docs',
    SECTION: '/docs/:section',
    ARTICLE: '/docs/:section/:slug',
  },
} as const;

/**
 * Build a concrete docs article URL from section + slug.
 */
export function docsArticlePath(section: string, slug: string): string {
  return `/docs/${section}/${slug}`;
}

export function docsSectionPath(section: string): string {
  return `/docs/${section}`;
}

/**
 * Helper to check if a route is public (doesn't require authentication)
 */
export function isPublicRoute(path: string): boolean {
  const authRoutes = Object.values(ROUTES.AUTH) as string[];
  return authRoutes.includes(path);
}

/**
 * Helper to check if a route is protected (requires authentication)
 */
export function isProtectedRoute(path: string): boolean {
  return !isPublicRoute(path);
}
